import React from "react"
import { FormControl, FormDescription, FormItem, FormMessage, useFormField } from "@ui/shad"
import { ControllerRenderProps, FieldValues, Path } from "react-hook-form"

import { NumberInput } from "../inputs/number-input"

interface NumberFieldProps<T extends FieldValues>
  extends Omit<React.ComponentProps<typeof NumberInput>, "value" | "onChange" | "onBlur" | "ref"> {
  id: string
  description?: string
  field: ControllerRenderProps<T, Path<T>>
}

export function NumberField<T extends FieldValues>({ field, id, description, ...props }: NumberFieldProps<T>) {
  const { error } = useFormField()

  return (
    <FormItem>
      <FormControl>
        <NumberInput id={id} error={!!error} {...field} {...props} />
      </FormControl>
      {description && <FormDescription>{description}</FormDescription>}
      <FormMessage />
    </FormItem>
  )
}

/* Example Usage:
interface FormData {
  age: number;
}

<FormField
  control={form.control}
  name="age"
  render={({ field }) => (
    <NumberField<FormData>
      field={field}
      id="age"
      label="Age"
      placeholder="Enter your age"
      min={0}
      max={120}
    />
  )}
/>
*/
